import React from "react";
import Modal from "react-bootstrap/Modal";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import cookie from "react-cookies";

import { clearAll } from "../../../Redux/Actions/userActions";
import { updateLoginState } from "../../../Request/UserRequests";
const SignOut = ({ showSignOut, setShowSignOut }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showSignOut}
      className="custom-modal"
      onHide={() => setShowSignOut(false)} 

    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Are you sure want to Sign Out?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-stretch">
          <button
            type="button"
            className="btn flex-fill btn-outline-secondary"
            onClick={() => setShowSignOut(false)}
          >
            No, Cancel
          </button>
          <div style={{ width: "16px" }}></div>
          <button
            type="button"
            className="btn flex-fill btn-outline-danger"
            onClick={() => {
              updateLoginState(false);
              dispatch(clearAll());
              cookie.remove("uid", { path: "/" });
              navigate("/");
            }}
          >
            Yes, Sign Out
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SignOut;
